import { ClientPointEvent, ContainerElement, pointer } from 'd3-selection';
import React from 'react';
import { roundTime } from '../../utils/math';
import { Scale } from '../types/scale';
import { useStrip } from './useStrip';

export const useEventTimestamp = () => {
  const { xScale } = useStrip();

  return (event: React.MouseEvent<ContainerElement>) =>
    toTimestamp(xScale, event.currentTarget, event);
};

const toTimestamp = (
  xScale: Scale,
  target: ContainerElement,
  event: ClientPointEvent,
): number => roundTime(xScale.invert(pointer(event, target)[0]));
